<template>
    <v-container>
        <template v-if="! tryout">
            <v-row justify="end" :dense="$vuetify.breakpoint.mdAndDown">
                <v-col v-for="n in 4" :key="n" cols="12" sm="6" lg="3">
                    <v-skeleton-loader type="image" height="150"></v-skeleton-loader>
                </v-col>
                <v-skeleton-loader type="button" class="mt-4"></v-skeleton-loader>
            </v-row>
        </template>
        <template v-else>
            <v-row justify="center" :dense="$vuetify.breakpoint.mdAndDown">
                <v-col cols="12" sm="6" lg="3">
                    <v-card>
                        <v-card-title>Soal</v-card-title>
                        <v-card-text class="display-1 text-right">{{ tryout.question_count }}</v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                    <v-card>
                        <v-card-title>Waktu</v-card-title>
                        <v-card-text class="display-1 text-right">{{ timer }}</v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                    <v-card>
                        <v-card-title>Dikerjakan</v-card-title>
                        <v-card-text class="display-1 text-right">{{ !!tryout.done_count ? tryout.done_count : 0 }}</v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                    <v-card>
                        <v-card-title>Rata-rata</v-card-title>
                        <v-card-text class="display-1 text-right">{{ !!tryout.average_grade ? tryout.average_grade : 'N/A' }}</v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <div class="text-right">
                <start-button
                    :state="state"
                    :historyHash="historyHash"
                    :tryout="tryout"
                ></start-button>
            </div>
        </template>

        <tryout-rank></tryout-rank>
    </v-container>
</template>

<script>
import minuteToHourMinuteSecond from '@/tools/minuteToHourMinuteSecond'
import StartButton from '@/components/dashboard/tryout/StartButton'
import TryoutRank from '@/components/dashboard/tryout/TryoutRank'

export default {
    components: {
        StartButton,
        TryoutRank,
    },

    data() {
        return {
            tryout: null,
            state: null,
            historyHash: null,
            routeInformation: null
        }
    },

    computed: {
        timer() {
            return minuteToHourMinuteSecond(this.tryout.minute_limit)
        }
    },

    async created() {
        const workResponse = await this.$api.get(`tryout/${this.$route.params.hash}/work`)
        this.state = workResponse.data.state
        this.historyHash = workResponse.data.hash

        const tryoutResopnse = await this.$api.get(`tryout/${this.$route.params.hash}`)
        this.tryout = tryoutResopnse.data
        this.$store.set('ui/title',this.tryout.title)

        this.$tracking.pageViewByTitle(
            this.tryout.title + ' ' + this.$store.get('enrollment/selected@title'),
            this.routeInformation
        )
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.routeInformation = { to, from }
        })
    }
}
</script>
